import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Navbar,
  Nav,
  Card,
  Badge,
  Image,
  Offcanvas,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Navigate, useNavigate } from "react-router-dom";
import {
  FaWhatsapp,
  FaFilePdf,
  FaShippingFast,
  FaPlane,
  FaShip,
  FaRocket,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaUserPlus,
  FaShoppingCart,
  FaWarehouse,
  FaHome,
  FaGift,
  FaCheckCircle,
  FaExclamationTriangle,
  FaDollarSign,
  FaHeadset,
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaShareAlt,
  FaClock,
  FaBox,
  FaMapMarkedAlt,
  FaTag,
  FaCreditCard,
  FaTruck,
  FaBoxOpen,
  FaLock,
  FaSmile,
  FaCalendarAlt,
  FaArrowUp,
  FaArrowDown,
  FaChevronRight,
  FaTimes,
  FaPlayCircle,
  FaPlay,
  FaBoxes,
  FaPallet,
  FaPlaneDeparture,
} from "react-icons/fa";

import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";

import inicio from "../../assets/inicio.png";
import logoMbox from "../../assets/MBOX-LOGO-BLANCO.png";
import video1 from "../../assets/Video1.mp4";
import video2 from "../../assets/Video2.mp4";
import video3 from "../../assets/video3.mp4";
import video4 from "../../assets/video4.mp4";

import mboxitoMexico from "../../assets/mboxitoMexico.png";
import mboxitoEEUU from "../../assets/mboxitoEEUU.png";

import deliveryAnim from "../../assets/Animation - 1748224957909.json";
import mascota from "../../assets/MBOXITO_MASCOTA.png";
import trackingAnimation from "../../assets/Animation - 1747624631532.json";
import boxAnimation from "../../assets/Animation - 1747626198371.json";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";


const MetricsSection = (props) => {
  const [metrics, setMetrics] = useState({ clientes: 0, paquetes: 0 });
  const container = { hidden: {}, show: { transition: { staggerChildren: 0.3 } } };
  const item = { hidden: { opacity: 0, y: 40 }, show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } } };
  const hoverEffect = { whileHover: { scale: 1.03, boxShadow: "0px 10px 30px rgba(0,0,0,0.15)" }, transition: { type: "spring", stiffness: 300 } };
  const stats = { lockers: { total: 3205, growth: 15.6 }, packages: { total: 9360, growth: 12.3 } };

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const API_HOST = process.env.REACT_APP_API_URL;
        const API_KEY = process.env.REACT_APP_API_KEY;
        
        const response = await fetch(`${API_HOST}/public/metrics`, {
          headers: {
            "API": API_KEY
          }
        });
        
        if (response && response.ok) {
          const data = await response.json();
          setMetrics({ clientes: data.totalClientes, paquetes: data.paquetesEntregados });
        }
      } catch (error) {
        console.error("Error obteniendo métricas", error);
      }
    };
    fetchMetrics();
  }, []);

  return (
    <section
          className='py-5'
          style={{
            background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
            color: "#182848",
          }}
        >
          <Container>
            {/* Título con colores warning */}
            <Row className='mb-5'>
              <Col className='text-center'>
                <motion.div
                  initial={{ opacity: 0, y: -30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  <h2 className='display-4 fw-bold mb-3'>
                    <span
                      className='text-dark'
                      style={{
                        background: "linear-gradient(90deg, #ffc107, #ff9800)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                      }}
                    >
                      Métricas{" "}
                    </span>
                    <span className='text-dark'>que Hablan por Nosotros</span>
                  </h2>
                  <div className='d-flex justify-content-center'>
                    <div
                      style={{
                        height: "4px",
                        width: "80px",
                        background: "linear-gradient(90deg, #ffc107, #ff9800)",
                        borderRadius: "2px",
                      }}
                    ></div>
                  </div>
                  <p className='lead mt-3' style={{ color: "#5a6a8a" }}>
                    El impacto real de nuestro servicio en números
                  </p>
                </motion.div>
              </Col>
            </Row>

            {/* Tarjetas con nuevos colores */}
            <Row className='align-items-center'>
              <Col lg={12}>
                <motion.div
                  variants={container}
                  initial='hidden'
                  whileInView='show'
                  viewport={{ once: true, amount: 0.3 }}
                >
                  <Row className='g-4 justify-content-center'>
                    {/* Tarjeta 1 - Casilleros (warning/naranja) */}
                    <Col sm={6} lg={3}>
                      <motion.div variants={item} {...hoverEffect}>
                        <Card
                          className='h-100 border-0 rounded-4 shadow-lg p-3 text-center'
                          style={{
                            background: "white",
                            borderBottom: "4px solid #ff9800",
                            transition: "all 0.3s ease",
                          }}
                        >
                          <Card.Body className='d-flex flex-column'>
                            <div className='mb-auto'>
                              <div
                                className='d-inline-flex justify-content-center align-items-center mb-4 rounded-circle'
                                style={{
                                  background:
                                    "linear-gradient(135deg, #ff980020, #ffc10720)",
                                  width: "80px",
                                  height: "80px",
                                }}
                              >
                                <FaLock size={32} color='#ff9800' />
                              </div>
                              <h4
                                className='mb-2 fw-semibold'
                                style={{ color: "#3a4a6a" }}
                              >
                                Casilleros Creados
                              </h4>
                            </div>
                            <div>
                              <div
                                className='display-4 fw-bold mb-2'
                                style={{ color: "#ff9800" }}
                              >
                                {metrics.clientes > 0 ? metrics.clientes.toLocaleString() : stats.lockers.total}
                              </div>
                              <div
                                className={`d-inline-flex align-items-center badge bg-${
                                  stats.lockers.growth >= 0
                                    ? "success"
                                    : "danger"
                                }-subtle text-${
                                  stats.lockers.growth >= 0
                                    ? "success"
                                    : "danger"
                                } fs-6 p-2 rounded-pill`}
                              >
                                {stats.lockers.growth >= 0 ? (
                                  <FaArrowUp className='me-1' size={14} />
                                ) : (
                                  <FaArrowDown className='me-1' size={14} />
                                )}
                                {Math.abs(stats.lockers.growth)}%
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </motion.div>
                    </Col>

                    {/* Tarjeta 2 - Paquetes (azul modificado) */}
                    <Col sm={6} lg={3}>
                      <motion.div variants={item} {...hoverEffect}>
                        <Card
                          className='h-100 border-0 rounded-4 shadow-lg p-3 text-center'
                          style={{
                            background: "white",
                            borderBottom: "4px solid #2196f3",
                            transition: "all 0.3s ease",
                          }}
                        >
                          <Card.Body className='d-flex flex-column'>
                            <div className='mb-auto'>
                              <div
                                className='d-inline-flex justify-content-center align-items-center mb-4 rounded-circle'
                                style={{
                                  background:
                                    "linear-gradient(135deg, #2196f320, #64b5f620)",
                                  width: "80px",
                                  height: "80px",
                                }}
                              >
                                <FaBoxOpen size={32} color='#2196f3' />
                              </div>
                              <h4
                                className='mb-2 fw-semibold'
                                style={{ color: "#3a4a6a" }}
                              >
                                Paquetes Entregados
                              </h4>
                            </div>
                            <div>
                              <div
                                className='display-4 fw-bold mb-2'
                                style={{ color: "#2196f3" }}
                              >
                                {metrics.paquetes > 0 ? metrics.paquetes.toLocaleString() : stats.packages.total.toLocaleString()}
                              </div>
                              <div
                                className={`d-inline-flex align-items-center badge bg-${
                                  stats.packages.growth >= 0
                                    ? "success"
                                    : "danger"
                                }-subtle text-${
                                  stats.packages.growth >= 0
                                    ? "success"
                                    : "danger"
                                } fs-6 p-2 rounded-pill`}
                              >
                                {stats.packages.growth >= 0 ? (
                                  <FaArrowUp className='me-1' size={14} />
                                ) : (
                                  <FaArrowDown className='me-1' size={14} />
                                )}
                                {Math.abs(stats.packages.growth)}%
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </motion.div>
                    </Col>

                    {/* Tarjeta 3 - Clientes satisfechos (verde) */}
                    <Col sm={6} lg={3}>
                      <motion.div variants={item} {...hoverEffect}>
                        <Card
                          className='h-100 border-0 rounded-4 shadow-lg p-3 text-center'
                          style={{
                            background: "white",
                            borderBottom: "4px solid #4caf50",
                            transition: "all 0.3s ease",
                          }}
                        >
                          <Card.Body className='d-flex flex-column'>
                            <div className='mb-auto'>
                              <div
                                className='d-inline-flex justify-content-center align-items-center mb-4 rounded-circle'
                                style={{
                                  background:
                                    "linear-gradient(135deg, #4caf5020, #81c78420)",
                                  width: "80px",
                                  height: "80px",
                                }}
                              >
                                <FaSmile size={32} color='#4caf50' />
                              </div>
                              <h4
                                className='mb-2 fw-semibold'
                                style={{ color: "#3a4a6a" }}
                              >
                                Clientes Satisfechos
                              </h4>
                            </div>
                            <div>
                              <div
                                className='display-4 fw-bold mb-2'
                                style={{ color: "#4caf50" }}
                              >
                                98%
                              </div>
                              <div className='d-inline-flex align-items-center badge bg-success-subtle text-success fs-6 p-2 rounded-pill'>
                                <FaArrowUp className='me-1' size={14} />
                                2% vs año anterior
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </motion.div>
                    </Col>

                    {/* Tarjeta 4 - Tiempo de entrega (púrpura) */}
                    <Col sm={6} lg={3}>
                      <motion.div variants={item} {...hoverEffect}>
                        <Card
                          className='h-100 border-0 rounded-4 shadow-lg p-3 text-center'
                          style={{
                            background: "white",
                            borderBottom: "4px solid #9c27b0",
                            transition: "all 0.3s ease",
                          }}
                        >
                          <Card.Body className='d-flex flex-column'>
                            <div className='mb-auto'>
                              <div
                                className='d-inline-flex justify-content-center align-items-center mb-4 rounded-circle'
                                style={{
                                  background:
                                    "linear-gradient(135deg, #9c27b020, #ba68c820)",
                                  width: "80px",
                                  height: "80px",
                                }}
                              >
                                <FaClock size={32} color='#9c27b0' />
                              </div>
                              <h4
                                className='mb-2 fw-semibold'
                                style={{ color: "#3a4a6a" }}
                              >
                                Tiempo de Entrega
                              </h4>
                            </div>
                            <div>
                              <div
                                className='display-4 fw-bold mb-2'
                                style={{ color: "#9c27b0" }}
                              >
                                <span style={{ fontSize: "2.5rem" }}>8-10</span>
                              </div>
                              <div className='d-inline-flex align-items-center badge bg-success-subtle text-success fs-6 p-2 rounded-pill'>
                                Días Hábiles
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </motion.div>
                    </Col>
                  </Row>
                </motion.div>
              </Col>

              {/* Mascota */}
              <Col lg={12} className='mt-5'>
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ once: true }}
                  className='text-center'
                >
                  <Image
                    src={mascota}
                    alt='Mascota de la empresa'
                    fluid
                    style={{
                      maxHeight: "250px",
                      filter: "drop-shadow(0 10px 15px rgba(0,0,0,0.1))",
                    }}
                  />
                </motion.div>
              </Col>
            </Row>

            {/* Fecha */}
            <Row className='mt-4'>
              <Col className='text-center'>
                <motion.div
                  className='d-inline-block px-4 py-2 rounded-pill'
                  style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ delay: 1, duration: 0.5 }}
                  viewport={{ once: true }}
                >
                  <p className='text-muted mb-0 small fw-semibold'>
                    <FaCalendarAlt className='me-2' />
                    Datos actualizados al martes, 27 de mayo de 2025
                  </p>
                </motion.div>
              </Col>
            </Row>
          </Container>
        </section>
  );
};

export default MetricsSection;
